export const SET_RIDE_BOOKING_TOTAL = 'SET_RIDE_BOOKING_TOTAL';
export const CLEAR_RIDE_BOOKING_TOTAL = 'CLEAR_RIDE_BOOKING_TOTAL';
export const GET_RIDE_BOOKING_PRICE = 'GET_RIDE_BOOKING_PRICE';